export default __webpack_public_path__ + "static/media/sl5-min.376336ae.jpg";